import { Fragment, useState } from "react";

import makeStyles from "styles/muiStylesCompat/makeStyles";
import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

import MyTextField from "components/Inputs/MyTextField";
import {
  companyContactEmailSchema,
  companyContactPhoneSchema,
} from "~/validation/contactFields";

const useStyles = makeStyles((theme) => ({
  leftColumn: {
    paddingRight: theme.spacing(4),
  },
  grow: {
    flexGrow: 1,
  },
  textField: {
    width: "100%",
  },
}));

const CompanyForm = (props) => {
  const [inputErrors, setInputErrors] = useState({
    contact_email: undefined,
    contact_phone: undefined,
  });

  const { values, updateValues } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const readOnly = !!values?.checked;

  const handleFormChange = ({ target }) => {
    let { value, name } = target;

    if (["contact_email"].indexOf(name) > -1) {
      value = value.toLowerCase();
    }

    setInputErrors((prev) => ({ ...prev, [target.name]: undefined }));
    updateValues({ [target.name]: value });
  };

  const validateEmailBlur = (raw) => {
    try {
      companyContactEmailSchema().validateSync(raw);
      setInputErrors((prev) => ({ ...prev, contact_email: undefined }));
    } catch (e) {
      setInputErrors((prev) => ({ ...prev, contact_email: e.message }));
    }
  };

  const validatePhoneBlur = (raw) => {
    try {
      companyContactPhoneSchema().validateSync(raw);
      setInputErrors((prev) => ({ ...prev, contact_phone: undefined }));
    } catch (e) {
      setInputErrors((prev) => ({ ...prev, contact_phone: e.message }));
    }
  };

  return (
    <Fragment>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
          <Grid container direction="row" spacing={1}>
            <Grid size={{ xs: 12 }}>
              <MyTextField
                autoFocus
                customLabel={t("Yrityksen nimi")}
                required
                id="company-name"
                name="name"
                value={values.name || ""}
                onChange={handleFormChange}
                slotProps={{
                  htmlInput: {
                    readOnly,
                  },
                }}
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <MyTextField
                autoFocus
                customLabel={t("Y-tunnus")}
                required
                id="company-business_id"
                name="business_id"
                value={values.business_id || ""}
                onChange={handleFormChange}
                slotProps={{
                  htmlInput: {
                    readOnly,
                  },
                }}
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Typography variant="subtitle1">
                {t("Yhteyshenkilön sähköposti")}
              </Typography>

              <TextField
                className={classes.textField}
                id="company-form-contact_email"
                slotProps={{
                  htmlInput: {
                    readOnly,
                  },
                  inputLabel: { shrink: true },
                }}
                fullWidth
                margin="dense"
                name="contact_email"
                onChange={handleFormChange}
                onBlur={(e) => validateEmailBlur(e.target.value)}
                required={true}
                type="email"
                value={values.contact_email || ""}
                variant="outlined"
                error={Boolean(inputErrors.contact_email)}
                helperText={inputErrors.contact_email}
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Typography variant="subtitle1">
                Yhteyshenkilön puhelin
              </Typography>

              <TextField
                className={classes.textField}
                fullWidth
                helperText={
                  inputErrors.contact_phone ??
                  "Käytä vain kansainvälistä muotoa"
                }
                id="company-form-company-phone"
                slotProps={{
                  htmlInput: {
                    readOnly,
                  },
                  inputLabel: { shrink: true },
                }}
                margin="dense"
                name="contact_phone"
                onChange={handleFormChange}
                onBlur={(e) => validatePhoneBlur(e.target.value)}
                required={true}
                value={values.contact_phone || ""}
                variant="outlined"
                error={Boolean(inputErrors.contact_phone)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default CompanyForm;
